(() => {
  const marker = document.querySelector('[data-bt-selectable-egift-page]');
  if (!marker) return;
  document.body.classList.add('bt-selectable-egift-page');

  let itemsObserver;
  const enhance = () => {
    const anyGiftRoot = document.querySelector('[data-anygift="ProductPageGiftUi"]');
    const target = document.querySelector('[data-bt-selectable-egift-target]');
    if (!anyGiftRoot || !target) return false;

    const ui = anyGiftRoot.querySelector('.anygift-e-gift-modal__ui');
    if (!ui) return false;
    const directChildren = [...ui.children];
    if (directChildren[0]) directChildren[0].textContent = 'eギフト専用商品';
    if (directChildren[1]) directChildren[1].textContent = '購入後に発行される受取URLを、LINEやSNSで贈れます。';

    const selectableTitle = ui.querySelector('.anygift-e-gift-modal__selectable-gift__title');
    const selectableDescription = ui.querySelector('.anygift-e-gift-modal__selectable-gift__description');
    if (selectableTitle) selectableTitle.textContent = '受け取る方が、商品を選べます';
    if (selectableDescription) selectableDescription.textContent = '商品・カラー・対応サイズ・配送先は、受け取る方が選択します。';

    const renderItems = (source) => {
      const viewAllSelector = '.anygift-e-gift-modal__selectable-gift__view-all';
      const itemSelector = '.anygift-e-gift-modal__selectable-gift__item';
      const restoreFocus = target.contains(document.activeElement) && document.activeElement.matches(viewAllSelector);
      const copy = source.cloneNode(true);
      source.hidden = true;
      copy.hidden = false;
      copy.setAttribute('data-bt-selectable-egift-list-copy', '');
      copy.querySelectorAll('button').forEach((button) => { button.type = 'button'; });
      // The original stays inside AnyGift's event root; clones need a click bridge.
      copy.addEventListener('click', (event) => {
        if (!(event.target instanceof Element)) return;
        const control = event.target.closest(viewAllSelector + ', ' + itemSelector);
        if (!control || !copy.contains(control)) return;
        event.preventDefault();
        event.stopPropagation();
        const original = control.matches(viewAllSelector)
          ? source.querySelector(viewAllSelector)
          : source.querySelectorAll(itemSelector)[[...copy.querySelectorAll(itemSelector)].indexOf(control)];
        if (!original) return;
        if (original.tagName === 'BUTTON') original.type = 'button';
        original.click();
      });
      target.replaceChildren(copy);
      if (restoreFocus) copy.querySelector(viewAllSelector)?.focus({ preventScroll: true });
    };

    const items = ui.querySelector('.anygift-e-gift-modal__selectable-gift__items');
    if (items && !target.querySelector('[data-bt-selectable-egift-list-copy]')) renderItems(items);
    if (items && !itemsObserver) {
      itemsObserver = new MutationObserver(() => {
        const updated = anyGiftRoot.querySelector('.anygift-e-gift-modal__selectable-gift__items');
        if (updated) renderItems(updated);
      });
      itemsObserver.observe(anyGiftRoot, { childList: true, subtree: true });
    }
    return Boolean(items);
  };

  if (enhance()) return;
  const observer = new MutationObserver(() => {
    if (enhance()) observer.disconnect();
  });
  observer.observe(document.body, { childList: true, subtree: true });
  window.setTimeout(() => observer.disconnect(), 20000);
})();
